// src/components/ChargingStation/ChargerInfo.tsx
import React from 'react';
import {
  View,
  Text,
  Image,
  Dimensions,
  Platform,
  StyleSheet,
} from 'react-native';
import LoadingPlaceholder from '../LoadingPlaceholder';
import DirectionsButton from '../DirectionsButton';
import { ActiveChargeAttributes } from '../../models/active-charges-model';
import { ChargerAttributes } from '../../models/charger-model';

const { width } = Dimensions.get('window');

interface ChargerInfoProps {
  renderCharger: ChargerAttributes;
  myDistanceFromCharger: string;
  myTimeFromCharger: string;
  activeCharges: ActiveChargeAttributes[] | null;
}

const ChargerInfo: React.FC<ChargerInfoProps> = ({
  renderCharger,
  myDistanceFromCharger,
  myTimeFromCharger,
  activeCharges,
}) => {
  return (
    <View className="mx-4">
      {Platform.OS === 'web' ? (
        renderCharger?.isOccupied === 1 || renderCharger?.is_enabled === false ? (
          <Text
            className="px-5 py-2 text-xs font-bold text-white rounded-full"
            style={[
              styles.BgColorInUse,
              {
                width: width <= 430 ? width * 0.3 : 100,
                textAlign: 'center',
              },
            ]}
          >
            In Use
          </Text>
        ) : (
          <Text
            className="px-5 py-2 text-xs font-bold text-white rounded-full"
            style={[
              styles.BgColor1,
              {
                width: width <= 430 ? width * 0.3 : 100,
                textAlign: 'center',
              },
            ]}
          >
            Available
          </Text>
        )
      ) : (
        <View
          style={{
            width: renderCharger?.isOccupied === 0 && renderCharger?.is_enabled === true ? 100 : 120,
            backgroundColor:
              renderCharger?.isOccupied === 0 && renderCharger?.is_enabled === true ? '#51B868' : '#F97777',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 23,
          }}
        >
          {renderCharger?.isOccupied === 0 && renderCharger?.is_enabled === true ? (
            <Text className="px-5 py-2 text-xs font-bold text-white">
              Available
            </Text>
          ) : (
            <Text className="px-5 py-2 text-xs font-bold text-white">
              In Use
            </Text>
          )}
        </View>
      )}
      <Text className="py-2 text-2xl font-bold text-white">
        {renderCharger?.name}
      </Text>
      <Text
        className="text-base font-normal text-white"
        style={styles.textColor}
      >
        {renderCharger?.full_address}
      </Text>
      <View className="flex flex-row flex-wrap justify-between items-center">
        <View className="flex flex-row gap-3">
          <Image
            source={require('../../../assets/LocationMarker.png')}
            style={{ height: 19, width: 19 }}
            alt="LocationMarker"
          />
          <Text className="text-white">
            {myDistanceFromCharger !== undefined ? (
              `${myDistanceFromCharger} miles`
            ) : (
              <LoadingPlaceholder />
            )}
          </Text>
          <Image
            source={require('../../../assets/DrivingCar.png')}
            style={{ height: 19, width: 19 }}
            alt="DrivingCar"
          />
          <Text className="text-white">
            {myTimeFromCharger !== undefined ? (
              `${myTimeFromCharger}`
            ) : (
              <LoadingPlaceholder />
            )}
          </Text>
        </View>
        <View>
          <DirectionsButton
            selectedCharger={renderCharger}
            buttonStyle={{
              paddingHorizontal: 20,
              paddingVertical: 8,
              borderRadius: 20,
              backgroundColor: styles.BgColor2.backgroundColor,
              marginTop: 20,
            }}
            textStyle={{
              fontSize: 14,
              fontWeight: '600',
              color: '#fff',
            }}
            webClassName="px-5 py-2 text-xs font-semibold text-white rounded-full"
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  BgColor1: {
    backgroundColor: '#51B868',
  },
  BgColor2: {
    backgroundColor: '#39BEB780',
  },
  textColor: {
    color: '#8D8E90',
  },
  BgColorInUse: {
    backgroundColor: '#F97777',
  },
});

export default ChargerInfo;
